'use client'

import React, { useRef } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons"
import { imageLoader } from "@/lib/functionloader"
import Image from "next/image"

import "swiper/css"
import "swiper/css/navigation"
import { Navigation } from "swiper/modules"

const BookOncheckcode = ({ data, mass }) => {
  const prevRef = useRef(null)
  const nextRef = useRef(null)

  const breakpoints = {
    640: { slidesPerView: 4, spaceBetween: 20 },
    960: { slidesPerView: 5, spaceBetween: 20 },
    1280: { slidesPerView: 6, spaceBetween: 20 },
    1440: { slidesPerView: 6, spaceBetween: 24 },
  }

  return (
    <>
      {/* หัวข้อ */}
      <div className="flex items-center gap-3 text-xl xl:text-2xl font-semibold my-4">
        <img
          src="https://eve-image.eveebook.com/image.eveebook/mascot/happy.png"
          alt="happy_rabbit"
          className="w-12 h-12"
        />
        {/* <div className="text-primary">รายการที่จะได้</div> */}
        {/* <div className="text-special">{mass}</div> */}
        <div className="py-[24px] text-primary">รายการที่จะได้</div>
        <div className="text-special">{mass}</div>
      </div>

      {/* Swiper + ปุ่ม */}
      <div className="relative">
        {/* ปุ่ม navigation */}
        <button
          ref={prevRef}
          className="swiper-prev-btn EbookSetSwiper absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow rounded-full w-10 h-10 flex items-center justify-center hover:bg-gray-100"
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        <button
          ref={nextRef}
          className="swiper-next-btn EbookSetSwiper absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow rounded-full w-10 h-10 flex items-center justify-center hover:bg-gray-100"
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>

        {/* swiper list */}
        <Swiper
          slidesPerView={2}
          spaceBetween={12}
          modules={[Navigation]}
          breakpoints={breakpoints}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current
            swiper.params.navigation.nextEl = nextRef.current
            swiper.navigation.init()
            swiper.navigation.update()
          }}
        >
          {(data || []).map((ebookdata, index) => {
            const bookName = ebookdata?.Edata?.name || ebookdata?.book_name || ebookdata?.name || "";
            const bookImage = ebookdata?.book_image || ebookdata?.book_cover || "";

            return (
              <SwiperSlide key={index}>
                <div className="group flex flex-col items-center w-[120px]">
                  {/* ปกหนังสือ */}
                  <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden shadow-md group-hover:shadow-lg transition-transform duration-300 group-hover:scale-105">
                    {bookImage ? (
                      <Image
                        src={bookImage}
                        loader={imageLoader}
                        alt={bookName || "cover"}
                        fill
                        className="object-cover"
                        sizes="100%"
                        loading="lazy"
                      />
                    ) : (
                      <div className="w-full h-full bg-indigo-900/50" />
                    )}
                  </div>

                  {/* ชื่อหนังสือ */}
                  <p className="mt-2 text-sm font-medium text-center text-gray-700 group-hover:text-primary transition-colors line-clamp-2 leading-snug h-[3.5rem] break-words">
                    {bookName}{" "}
                    {ebookdata?.series_number > 0 ? `เล่ม ${ebookdata.series_number}` : ""}
                  </p>
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
    </>
  )
}

export default BookOncheckcode
